// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createCustomError } from "@nevware21/ts-utils";
import { _DYN_LENGTH, _DYN_VALUE } from "../../../__DynamicConstants";
import { STR_EMPTY } from "../../../constants/InternalConstants";
import { getOpenTelemetryError } from "./OTelError";
var otelInvalidAttributeErrorType;
export function throwOTelInvalidAttributeError(message, attribName, value) {
    if (!otelInvalidAttributeErrorType) {
        otelInvalidAttributeErrorType = createCustomError("OTelInvalidAttributeError", function (self, args) {
            var len = args[_DYN_LENGTH /* @min:%2elength */];
            self.attribName = len > 1 ? args[1] : STR_EMPTY;
            self[_DYN_VALUE /* @min:%2evalue */] = len > 2 ? args[2] : STR_EMPTY;
        }, getOpenTelemetryError());
    }
    throw new otelInvalidAttributeErrorType(message, attribName, value);
}
//# sourceMappingURL=OTelInvalidAttributeError.js.map